// Angular modules.
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IBusySlot } from 'app/interfaces/availability.interface';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import { DateTimeService } from 'app/services/datetime.service';
// Services
import { PromptuarySidebarService } from 'modules/promptuary/services/sidebar/promptuary-sidebar.service';

// Interfaces

@Component({
	selector: 'appointment-preview-item',
	templateUrl: './appointment-preview-item.component.html',
	styleUrls: ['./appointment-preview-item.component.scss'],
})
export class AppointmentPreviewItemComponent {
	@Input() isPromptuaryCard: boolean;
	@Input() events: (IBusySlot | ICalendarEvent)[];

	@Output() showEventDetails: EventEmitter<any> = new EventEmitter<any>();

	icons = {
		cancelled: 'times',
		invite: 'paper-plane',
		new: 'asterisk',
		paid: 'check-circle',
		reschedule: 'clock',
		reschedule_request: 'clock',
		reserved: 'clock',
	};

	constructor(
		private dateTime: DateTimeService,
		private router: Router,
		private promptuarySidebarService: PromptuarySidebarService
	) {}

	showDetails(event: any) {
		if (!this.isPromptuaryCard) {
			return this.showEventDetails.emit(event);
		}

		const appointmentId = event.id;
		const clientId = event.profileId;

		this.promptuarySidebarService.openSidebarOrGoToPage(
			clientId,
			appointmentId,
			'appointment-alert'
		);
	}
}
